import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, Transition as _Transition, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "max-w-[1280px] w-full mx-auto" }

import { ref } from "vue";
import Menu from "./Menu.vue";
import { enter, leave } from "@/components/MainMenu/main-menu";
import MenuLink from "./MenuLink.vue";
import { FormattedMenu, nestedMenu } from "../SideMenu/side-menu";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileMenuComponent',
  props: {
  menu: Object,
  isRoot: Boolean,
  position: String,
  menuIndex: Number,
  setActiveMobileMenu: Function,
},
  setup(__props) {

const props = __props


const formattedMenu = ref([]);
const setFormattedMenu = (
  computedFormattedMenu: Array<FormattedMenu | "divider">
) => {
  formattedMenu.value = computedFormattedMenu;
};

return (_ctx: any,_cache: any) => {
  const _component_MobileMenuComponent = _resolveComponent("MobileMenuComponent", true)!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(MenuLink, {
      menu: __props.menu,
      formattedMenuState: [formattedMenu.value, setFormattedMenu],
      level: "first",
      setActiveMobileMenu: __props.setActiveMobileMenu
    }, null, 8, ["menu", "formattedMenuState", "setActiveMobileMenu"]),
    _createVNode(_Transition, {
      onEnter: _unref(enter),
      onLeave: _unref(leave)
    }, {
      default: _withCtx(() => [
        (__props.menu.subMenu?.length && __props.menu.activeDropdown)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: _normalizeClass([
          {'mx-4': __props.isRoot},
          {'mx-2 pb-1': !__props.isRoot},
          'bg-black/10 rounded-lg my-1 dark:bg-white/5',
          !__props.menu.activeDropdown && 'hidden',
          __props.menu.activeDropdown && 'block',
        ])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menu.subMenu, (menu, index) => {
                return (_openBlock(), _createBlock(_component_MobileMenuComponent, {
                  key: index,
                  menu: menu,
                  isRoot: false,
                  setActiveMobileMenu: __props.setActiveMobileMenu
                }, null, 8, ["menu", "setActiveMobileMenu"]))
              }), 128))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onEnter", "onLeave"])
  ]))
}
}

})